import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Style/EditModal.scss";
import "../../Style/FiscalCashRegisterForm.scss";
import "../../Style/TableStyle.scss";
import "../../Style/__searchbar.scss";
import "../../Style/__button.scss";
import InsertData from "./InsertFiscalCashRegister";
import {
  deleteAlert,
  errorAlert,
  handleSuccess,
} from "../../Components/Alerts";
import authHeader from "../../Auth/authHeader";
import { ApiLink } from "../../APILink/ApiLink";
import { FaCashRegister } from "react-icons/fa6";
import "jspdf-autotable";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
import TextField from "@mui/material/TextField";
import DataGridWithActions from "../../Components/DataGridWithActions";
import {
  ElementsParagraph,
  TitleElements,
} from "../../Components/HeadersCRUD-s";
import fiscalCashregisterHeader from "./FiscalCashRegisterGrid";
import { formatDate } from "../../Components/formatDate";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { MdRefresh } from "react-icons/md";
import { getCompanyUnits } from "../../GetData/CompanyUnitsData";
export default function FiscalCashRegister() {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    Id: "",
    CashRegisterHash: "",
    POSID: "",
    CompanyID: "",
    LocationName: "",
    Description: "",
    IsActive: false,
    UnitID: 0,
    ATKBranchID: "",
    ExternalModuleCode: "",
    MaxSecondaryDevices: 0,
    ATKPOSID: "",
    ATKAppicationID: "",
    ATKFiscalizationNumber: "",
    ATKSEFCode: "",
    ATKPrivateKeyPemEncrypted: "",
    ATKSignedCertificatePem: "",
    ATKEnvironment: null,
  });
  const [company, setCompany] = useState([]);
  const [paymentsAccounts, setPaymentsAccounts] = useState([]);
  const [companyUnits, setCompanyUnits] = useState([]);
  const [externalModules, setExternalModules] = useState([]);

  const [showEditModal, setShowEditModal] = useState(false);

  const fetchData = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "FiscalCashRegister", {
        headers,
      });
      setData(response.data);
      console.log(response.data);
      
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const headers = authHeader();
  const email = LoginUserDetailed(); // replace with your implementation of LoginUserDetailed()

  const handleDelete = async (deleteItemId) => {
    try {
      const response = await axios.delete(
        ApiLink.API_URL + "FiscalCashRegister" + `/${deleteItemId}`,
        { headers },
      );

      const result = response.data;

      if (result.success) {
        handleSuccess("Regjistri u fshi me sukses."); // Mesazhi i suksesit
        fetchData(); // Rimbush të dhënat pas fshirjes
      } else {
        deleteAlert(result.message || "Fshirja nuk u krye."); // Mesazhi nga backend në rast dështimi
      }
    } catch (error) {
      deleteAlert("Ndodhi një gabim gjatë fshirjes."); // Mesazh për gabime të tjera
    }
  };

  const handlePrepareReactivation = async (item) => {
    const deviceId = item?.DeviceId ?? item?.deviceId;
    if (!deviceId) {
      errorAlert("Kjo arkë nuk ka pajisje digjitale të lidhur për riaktivizim.");
      return;
    }

    const confirmed = window.confirm(
      "Ky veprim e çaktivizon sekretin aktual dhe kërkon riaktivizimin e arkës digjitale. DeviceId do të ruhet. Të vazhdohet?",
    );
    if (!confirmed) return;

    const reason = window.prompt("Shkruaj arsyen e riaktivizimit:", "Reset i kontrolluar i DeviceSecret");
    if (reason === null) return;
    if (reason.trim().length < 3) {
      errorAlert("Arsyeja duhet të ketë së paku 3 karaktere.");
      return;
    }

    try {
      const response = await axios.post(
        `${ApiLink.API_URL}FiscalCashRegister/${item.Id}/prepare-reactivation`,
        { reason: reason.trim() },
        { headers },
      );
      handleSuccess(response.data?.message || "Pajisja është gati për riaktivizim.");
      await fetchData();
    } catch (error) {
      const message = error?.response?.data?.message || "Përgatitja e riaktivizimit dështoi.";
      errorAlert(message, error);
    }
  };

  //   //Kodi per shfaqjen e formes per editimin e te dhenave ne databaz
  //   const handleEdit = (item) => {
  //     fetchPaymentsAccount(item.CompanyID);
  //     const units = getCompanyUnits(item.CompanyID);
  //     setCompanyUnits(units);

  //     setFormData({
  //       Id: item.Id,
  //       CashRegisterHash: item.CashRegisterHash,
  //       POSID: item.POSID,
  //       CompanyID: item.CompanyID,
  //       LocationName: item.LocationName,
  //       Description: item.Description,
  //       IsActive: item.IsActive,
  //       ModifiedByUser: email,
  //       UnitID: item.UnitID,
  //     });
  //     setShowEditModal(true);
  //   };

  // Shto 'async' këtu
  const handleEdit = async (item) => {
    try {
      fetchPaymentsAccount(item.CompanyID);

      const units = await getCompanyUnits(item.CompanyID);
      setCompanyUnits(units);

      console.log(item);
      
      setFormData({
        Id: item.Id,
        CashRegisterHash: item.CashRegisterHash,
        POSID: item.POSID,
        CompanyID: item.CompanyID,
        LocationName: item.LocationName,
        Description: item.Description,
        IsActive: item.IsActive,
        ModifiedByUser: email,
        UnitID: item.UnitID,
        ATKBranchID: item.ATKBranchID || "",
        ExternalModuleCode: item.ExternalModuleCode || "",
        MaxSecondaryDevices:
          item.MaxSecondaryDevices ?? item.maxSecondaryDevices ?? 0,
        ATKPOSID: item.ATKPOSID,
        ATKAppicationID: item.ATKAppicationID,
        ATKFiscalizationNumber: item.ATKFiscalizationNumber,
        ATKSEFCode: item.ATKSEFCode || "",
        ATKPrivateKeyPemEncrypted: item.ATKPrivateKeyPemEncrypted || "",
        ATKSignedCertificatePem: item.ATKSignedCertificatePem || "",
        ATKEnvironment: item.ATKEnvironment ?? item.atkEnvironment ?? null,
      });

      setShowEditModal(true);
    } catch (error) {
      console.error("Gabim gjatë procesimit të editimit:", error);
    }
  };

  // Kodi per ruajtjen e te dhenave pas editimint
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  //Dergimi i kerkeses per editimin e te dhenave ne backend
  const handleSubmit = (event) => {
    event.preventDefault();

    const parsedMaxSecondaryDevices = Number(formData.MaxSecondaryDevices);
    if (
      formData.MaxSecondaryDevices === "" ||
      !Number.isInteger(parsedMaxSecondaryDevices) ||
      parsedMaxSecondaryDevices < 0
    ) {
      errorAlert(
        "Numri i pajisjeve Secondary duhet të jetë numër i plotë, zero ose më i madh.",
      );
      return;
    }

    const updateData = {
      ...formData,
      MaxSecondaryDevices: Number(formData.MaxSecondaryDevices ?? 0),
    };

    axios
      .put(ApiLink.API_URL + "FiscalCashRegister", updateData, { headers })
      .then((response) => {
        setShowEditModal(false); // Close the edit modal
        fetchData();
        handleSuccess("P.O.S-i u editua me sukses");
      })
      .catch((error) => {
        console.error("FiscalCashRegister edit failed:", error?.response?.data || error);
        errorAlert("P.O.S-i nuk u editua.", error);
      });
  };

  const rows = data.map((item, index) => ({
    id: ++index,
    companyName: item.CompanyName,
    idnumber: item.IdentificationNumber,
    posName: item.AccountName,
    location: item.LocationName,
    description: item.Description,
    isActive: item.IsActive,
    registrationDate: formatDate(item.RegistrationDate),
    fiscalYear: item.FiscalYear,
    externalModuleCode: item.ExternalModuleCode,
    atkPOSID: item.ATKPOSID,
    atkAppicationID: item.ATKAppicationID,
    atkFiscalizationNumber: item.ATKFiscalizationNumber,
    atkSEFCode: item.ATKSEFCode,
    deviceId: item.DeviceId ?? item.deviceId,
    isActivated: item.IsActivated ?? item.isActivated,
    deleteItemId: item.Id,
    rowInfo: item,
  }));

  const gridColumns = [
    ...fiscalCashregisterHeader,
    {
      field: "sefActivation",
      headerName: "SEF i aktivizuar",
      width: 160,
      align: "center",
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const item = params.row.rowInfo;
        const isActivated = Boolean(item?.IsActivated ?? item?.isActivated);
        const deviceId = item?.DeviceId ?? item?.deviceId;

        if (!isActivated) {
          return (
            <Chip
              label={deviceId ? "Në pritje" : "Jo"}
              size="small"
              color={deviceId ? "warning" : "default"}
              variant={deviceId ? "filled" : "outlined"}
            />
          );
        }

        if (!deviceId) return <Chip label="Po" size="small" color="success" />;

        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", width: "100%" }}>
            <Chip label="Po" size="small" color="success" />
            <Tooltip title="Riaktivizo arkën digjitale">
              <IconButton
                size="small"
                aria-label="Riaktivizo arkën digjitale"
                onClick={() => handlePrepareReactivation(item)}
                sx={{ color: "#466F86" }}
              >
                <MdRefresh size={19} />
              </IconButton>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    Promise.all([
      axios.get(ApiLink.API_URL + "companies", { headers }),
      axios.get(ApiLink.API_URL + "License/getSystemModule", { headers }),
    ])
      .then(([companiesResponse, modulesResponse]) => {
        setCompany(companiesResponse.data || []);
        const onlyExternalModules = (modulesResponse.data || []).filter(
          (item) => Number(item?.IsExternal) === 1 && Number(item?.IsActive) === 1,
        );
        setExternalModules(onlyExternalModules);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const fetchPaymentsAccount = async (id) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedgerandCompany",
        { headers, params: { ledger: 101, id: id } },
      );
      setPaymentsAccounts(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //   const handleAutocompleteChangeCompany = (event, value) => {
  //     if (value) {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         CompanyID: value.CompanyID,
  //       }));
  //       fetchPaymentsAccount(value.CompanyID);

  //             const units = await getCompanyUnits(item.CompanyID);
  //       setCompanyUnits(units);
  //     } else {
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         CompanyID: "",
  //       }));
  //     }
  //   };

  // Shto 'async' këtu para (event, value)
  const handleAutocompleteChangeCompany = async (event, value) => {
    if (value) {
      setFormData((prevState) => ({
        ...prevState,
        CompanyID: value.CompanyID,
      }));

      fetchPaymentsAccount(value.CompanyID);

      try {
        // Përdor 'value.CompanyID' (jo item) dhe 'await'
        const units = await getCompanyUnits(value.CompanyID);
        setCompanyUnits(units);
      } catch (error) {
        console.error("Gabim gjatë marrjes së njësive:", error);
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        CompanyID: "",
      }));
      setCompanyUnits([]); // Sugjerim: zbraz listën nëse fshihet kompania
    }
  };

  const defaultPropsCompany = {
    options: company,
    getOptionLabel: (option) => option.CompanyName || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.CompanyName}</span>
        </li>
      </>
    ),
  };

  const handleAutocompletePaymentOptions = (event, value) => {
    if (value) {
      setFormData((prevState) => ({
        ...prevState,
        POSID: value.AccountID,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        POSID: "",
      }));
    }
  };

  const defaultPropsPaymentOptions = {
    options: paymentsAccounts,
    getOptionLabel: (option) => option.AccountName || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.AccountName}</span>
        </li>
      </>
    ),
  };

  const handleAutocompleteCompanyUnit = (event, value) => {
    if (value) {
      setFormData((prevState) => ({
        ...prevState,
        UnitID: value.UnitID,
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        UnitID: "",
      }));
    }
  };

  const defaultPropsCompanyUnit = {
    options: companyUnits,
    getOptionLabel: (option) => option.UnitName || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.UnitName}</span>
        </li>
      </>
    ),
  };

  const defaultPropsExternalModule = {
    options: externalModules,
    getOptionLabel: (option) => option.ModuleName || "",
    isOptionEqualToValue: (option, value) =>
      (option.ModuleCode || "").trim().toUpperCase() ===
      (value.ModuleCode || "").trim().toUpperCase(),
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.ModuleName}</span>
        </li>
      </>
    ),
  };

  const handleAutocompleteExternalModule = (event, value) => {
    if (value) {
      setFormData((prevState) => ({
        ...prevState,
        ExternalModuleCode: value.ModuleCode || "",
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        ExternalModuleCode: "",
      }));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="Crud__Container">
      {/* Shfaqja  e modalit per editimin e te dhenave  */}
      {showEditModal && (
        <div className="edit-modal-wrapper fcr-edit-overlay">
          <div className="edit-modal fcr-edit-modal">
            <form onSubmit={handleSubmit} className="fcr-form">
              <div className="fcr-form__header">
                <div>
                  <h3 className="fcr-form__title">Edito P.O.S</h3>
                  <p className="fcr-form__subtitle">
                    Përditëso konfigurimin operativ dhe fiskal të arkës.
                  </p>
                </div>
                <span className="fcr-form__badge fcr-form__badge--edit">Editim</span>
              </div>

              <div className="fcr-form__body">
                <section className="fcr-form__section">
                  <div className="fcr-form__section-header">
                    <span>1</span>
                    <div>
                      <h4>Identifikimi i P.O.S</h4>
                      <p>Kompania, arka, njësia dhe lokacioni i konfigurimit.</p>
                    </div>
                  </div>
                  <div className="fcr-form__grid fcr-form__grid--two">
                    <TextField
                      fullWidth
                      required
                      id="CashRegisterHash"
                      label="Hash Code"
                      variant="outlined"
                      type="text"
                      name="CashRegisterHash"
                      value={formData.CashRegisterHash}
                      InputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      required
                      id="LocationName"
                      label="Lokacioni"
                      variant="outlined"
                      type="text"
                      name="LocationName"
                      value={formData.LocationName}
                      onChange={handleInputChange}
                    />
                    <Autocomplete
                      fullWidth
                      {...defaultPropsCompany}
                      id="CompanyID"
                      name="CompanyID"
                      includeInputInList
                      onChange={handleAutocompleteChangeCompany}
                      renderInput={(params) => (
                        <TextField {...params} label="Kompania" />
                      )}
                      ListboxProps={{
                        style: {
                          maxHeight: "220px",
                          overflow: "auto",
                        },
                      }}
                      value={
                        company.find(
                          (option) => option.CompanyID === formData.CompanyID,
                        ) || null
                      }
                    />
                    <Autocomplete
                      fullWidth
                      {...defaultPropsPaymentOptions}
                      id="POSID"
                      name="POSID"
                      includeInputInList
                      onChange={handleAutocompletePaymentOptions}
                      renderInput={(params) => (
                        <TextField {...params} label="Arka" />
                      )}
                      ListboxProps={{
                        style: {
                          maxHeight: "220px",
                          overflow: "auto",
                        },
                      }}
                      value={
                        paymentsAccounts.find(
                          (option) => option.AccountID === formData.POSID,
                        ) || null
                      }
                    />
                    <Autocomplete
                      fullWidth
                      {...defaultPropsCompanyUnit}
                      id="UnitID"
                      name="UnitID"
                      includeInputInList
                      onChange={handleAutocompleteCompanyUnit}
                      renderInput={(params) => (
                        <TextField {...params} label="Njësia organizative" />
                      )}
                      ListboxProps={{
                        style: {
                          maxHeight: "220px",
                          overflow: "auto",
                        },
                      }}
                      value={
                        companyUnits.find(
                          (option) => option.UnitID === formData.UnitID,
                        ) || null
                      }
                    />
                    <Autocomplete
                      fullWidth
                      {...defaultPropsExternalModule}
                      id="ExternalModuleCode"
                      name="ExternalModuleCode"
                      includeInputInList
                      onChange={handleAutocompleteExternalModule}
                      renderInput={(params) => (
                        <TextField {...params} label="Moduli i jashtëm" />
                      )}
                      ListboxProps={{
                        style: {
                          maxHeight: "220px",
                          overflow: "auto",
                        },
                      }}
                      value={
                        externalModules.find(
                          (option) =>
                            (option.ModuleCode || "").trim().toUpperCase() ===
                            (formData.ExternalModuleCode || "").trim().toUpperCase(),
                        ) || null
                      }
                    />
                    <TextField
                      fullWidth
                      required
                      id="MaxSecondaryDevices"
                      label="Numri maksimal i pajisjeve Secondary"
                      variant="outlined"
                      type="number"
                      name="MaxSecondaryDevices"
                      value={formData.MaxSecondaryDevices ?? 0}
                      onChange={handleInputChange}
                      onInvalid={(event) => {
                        event.preventDefault();
                        errorAlert(
                          "Numri i pajisjeve Secondary duhet të jetë numër i plotë, zero ose më i madh.",
                        );
                      }}
                      inputProps={{ min: 0, step: 1 }}
                    />
                  </div>
                </section>

                <section className="fcr-form__section">
                  <div className="fcr-form__section-header">
                    <span>2</span>
                    <div>
                      <h4>Konfigurimi fiskal ATK</h4>
                      <p>Identifikuesit fiskalë që kërkohen për fiskalizim.</p>
                    </div>
                  </div>
                  <div className="fcr-form__grid fcr-form__grid--four">
                    <TextField
                      fullWidth
                      id="ATKBranchIDSection2"
                      label="Branch ID nga ATK"
                      variant="outlined"
                      type="number"
                      name="ATKBranchID"
                      value={formData.ATKBranchID || ""}
                      InputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      required
                      id="ATKPOSID"
                      label="ATK POS ID"
                      variant="outlined"
                      type="number"
                      name="ATKPOSID"
                      value={formData.ATKPOSID}
                      onChange={handleInputChange}
                      InputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      required
                      id="ATKAppicationID"
                      label="ATK Application ID"
                      variant="outlined"
                      type="number"
                      name="ATKAppicationID"
                      value={formData.ATKAppicationID}
                      onChange={handleInputChange}
                      InputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      required
                      id="ATKFiscalizationNumber"
                      label="ATK Fiscalization Number"
                      variant="outlined"
                      type="text"
                      name="ATKFiscalizationNumber"
                      value={formData.ATKFiscalizationNumber}
                      onChange={handleInputChange}
                      InputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      required
                      id="ATKSEFCode"
                      label="ATK SEF Code"
                      variant="outlined"
                      type="text"
                      name="ATKSEFCode"
                      value={formData.ATKSEFCode}
                      onChange={handleInputChange}
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                </section>

                <section className="fcr-form__section">
                  <div className="fcr-form__section-header">
                    <span>3</span>
                    <div>
                      <h4>Certifikatat dhe çelësat</h4>
                      <p>Private key i enkriptuar dhe certifikata e nënshkruar.</p>
                    </div>
                  </div>
                  <div className="fcr-form__grid fcr-form__grid--two">
                    <TextField
                      fullWidth
                      required
                      id="ATKPrivateKeyPemEncrypted"
                      label="ATK Private Key Pem Encrypted"
                      variant="outlined"
                      name="ATKPrivateKeyPemEncrypted"
                      type="password"
                      value={formData.ATKPrivateKeyPemEncrypted || ""}
                      InputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      required
                      id="ATKSignedCertificatePem"
                      label="ATK Signed Certificate Pem"
                      variant="outlined"
                      name="ATKSignedCertificatePem"
                      type="password"
                      value={formData.ATKSignedCertificatePem || ""}
                      InputProps={{ readOnly: true }}
                    />
                  </div>
                </section>

                <section className="fcr-form__section">
                  <div className="fcr-form__section-header">
                    <span>4</span>
                    <div>
                      <h4>Statusi dhe përshkrimi</h4>
                      <p>Gjendja aktive e P.O.S dhe shënime të brendshme.</p>
                    </div>
                  </div>
                  <div className="fcr-form__grid">
                    <TextField
                      fullWidth
                      id="Description"
                      label="Përshkrimi"
                      variant="outlined"
                      type="text"
                      name="Description"
                      multiline
                      minRows={3}
                      value={formData.Description}
                      onChange={handleInputChange}
                    />
                  </div>
                </section>
              </div>

              <div className="fcr-form__footer">
                <label className="fcr-form__switch">
                  <input
                    type="checkbox"
                    id="IsActive"
                    name="IsActive"
                    checked={formData.IsActive}
                    onChange={(event) =>
                      setFormData({
                        ...formData,
                        IsActive: event.target.checked,
                      })
                    }
                  />
                  <span></span>
                  P.O.S aktiv
                </label>
                <div className="fcr-form__actions">
                  <button
                    type="button"
                    className="fcr-form__secondary-button"
                    onClick={() => setShowEditModal(false)}
                  >
                    Anulo
                  </button>
                  <button type="submit" className="fcr-form__primary-button">
                    Ruaj ndryshimet
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Tabela per shfaqjen e te dhenave  */}
      <div className="header_flex">
        <TitleElements icon={FaCashRegister} title="Menaxhimi i P.O.S" />
        <div>
          <InsertData fetchData={fetchData} type={"text"} />
        </div>
      </div>
      <ElementsParagraph text="Forma e P.O.S: Menaxhoni, shtoni, editoni dhe fshini P.O.S." />

      <DataGridWithActions
        columns={gridColumns}
        rows={rows}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        showDelete={false}
        showPayment={false}
        height={500}
      />
    </div>
  );
}
